// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3tClP","title":"AfterFrontImage_title__2dUPq"};